import React from "react";
import { List } from "@refinedev/mui";
import { Box, Grid2 as Grid, Tab, Tabs } from "@mui/material";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import NewspaperIcon from "@mui/icons-material/Newspaper";

import { DataGrid } from "@shared/components/DataGrid";
import { ConditionalGrid, FilterDropdown, SummaryCard } from "@shared/components";
import { ReceivedBookListFilters, ReceivedBookPeriods } from "@modules/receivedBooks/components";

import { useReceivedBookList } from "./controller";
import { useReceivedBookListColumns } from "./columns";

export const ReceivedBookList = React.memo(() => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const {
    rows,
    loading,
    rowCount,
    tableProps,
    monthlyReport,
    isLoadingReport,
  } = useReceivedBookList();

  const columns = useReceivedBookListColumns();
  const statistics = monthlyReport?.statistics;

  return (
    <List
      headerButtons={
        <FilterDropdown
          initialValues={{
            agreement_id: "",
            product_id: "",
            document: "",
            month: "",
            year: "",
            book_type: "",
            isbn: "",
            issn: "",
          }}
        >
          <ReceivedBookListFilters />
        </FilterDropdown>
      }
    >
      <Box>
        <Tabs
          value={selectedTab}
          onChange={(_, v) => setSelectedTab(v)}
          sx={{ mb: 2 }}
        >
          <Tab label="Estatísticas" />
          <Tab label="Tabela" />
        </Tabs>

        <ConditionalGrid container spacing={2} isVisible={selectedTab === 0}>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<LocalShippingIcon />}
              label="Total Entregue"
              value={statistics?.total_delivered?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<CollectionsBookmarkIcon />}
              label="Total de Mídias"
              value={statistics?.total_media?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<CalendarMonthIcon />}
              label="Períodos"
              value={statistics?.total_periods?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<AutoStoriesIcon />}
              label="E-books"
              value={statistics?.total_ebooks?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<HeadphonesIcon />}
              label="Audiobooks"
              value={statistics?.total_audiobooks?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <SummaryCard
              icon={<NewspaperIcon />}
              label="Revistas"
              value={statistics?.total_magazines?.toLocaleString("pt-BR") ?? "—"}
              loading={isLoadingReport}
            />
          </Grid>

          <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
            <ReceivedBookPeriods
              periods={monthlyReport?.data}
              loading={isLoadingReport}
            />
          </Grid>
        </ConditionalGrid>

        <ConditionalGrid container spacing={2} isVisible={selectedTab === 1}>
          <Grid size={{ xs: 12 }}>
            <DataGrid
              {...tableProps}
              rows={rows}
              columns={columns}
              loading={loading}
              rowCount={rowCount}
            />
          </Grid>
        </ConditionalGrid>
      </Box>
    </List>
  );
});
